import React from 'react';
import { PropTypes } from 'prop-types';

import useFieldsController from './useFieldsController';
import Buttons from './Buttons';
import EventForm from '../../components/EventForm';

const Wrapper = ({
  values,
  settings,
  validateForm,
  setValue,
  isValid,
  onBackPress,
  handleSubmit,
  saveButtonTitle,
}) => {
  useFieldsController(values, setValue);

  return (
    <EventForm
      operation="write"
      values={values}
      settings={settings}
      validateForm={validateForm}
      setValue={setValue}
    >
      <Buttons
        isValid={isValid}
        back={onBackPress}
        handleSubmit={handleSubmit}
        saveButtonTitle={saveButtonTitle}
      />
    </EventForm>
  );
};

Wrapper.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  validateForm: PropTypes.func.isRequired,
  values: PropTypes.shape({}).isRequired,
  onBackPress: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  saveButtonTitle: PropTypes.string.isRequired,
  settings: PropTypes.shape({}).isRequired,
};
export default Wrapper;
